// extracted by mini-css-extract-plugin
module.exports = {"control":"Pagination_control__MkIxJ"};